var _circle, _g, _rect, _g2, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _path4, _rect8, _path5, _path6, _path7, _path8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 142,
    r: 120,
    fill: "#F3F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35209_77808)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 48,
    width: 229.6,
    height: 165.2,
    rx: 4,
    fill: "#AFBAC9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 52,
    width: 222,
    height: 146,
    rx: 2,
    fill: "#F3F6FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_35209_77808)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_35209_77808",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 65H227V198H53V65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53 65H227V198H53V65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 197.5H53V198.5H227V197.5Z",
    fill: "#AFBAC9",
    mask: "url(#path-4-inside-1_35209_77808)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.3999,
    y: 241.2,
    width: 109.2,
    height: 2.8,
    rx: 1.4,
    fill: "#A0AFC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.8 213.2C114.8 213.2 114.8 241.2 86.8 241.2H193.2C193.2 241.2 166.6 238.4 166.6 213.2H114.8Z",
    fill: "url(#paint0_linear_35209_77808)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54C29 52.8954 29.8954 52 31 52H249C250.105 52 251 52.8954 251 54V65H29V54Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65H251V66H29V65Z",
    fill: "#AFBAC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 72,
    width: 156,
    height: 32,
    rx: 4,
    fill: "#34A597",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 91,
    width: 23,
    height: 8,
    rx: 4,
    fill: "#34A597"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 108,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#407DD8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 108,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#F3F6FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 108,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#F3F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 118H227V117H53V118Z",
    fill: "#F3F6FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.75,
    y: 170.875,
    width: 9.5,
    height: 1.78125,
    fill: "#407DD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1875 176.812L75.3125 160.188H77.6875L70.5625 176.812H68.1875Z",
    fill: "#407DD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8125 176.812L77.6875 160.188H75.3125L82.4375 176.812H84.8125Z",
    fill: "#407DD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.375 135.5C69.375 139.435 72.565 142.625 76.5 142.625C80.435 142.625 83.625 139.435 83.625 135.5C83.625 131.565 80.435 128.375 76.5 128.375C72.565 128.375 69.375 131.565 69.375 135.5ZM76.5 126C71.2533 126 67 130.253 67 135.5C67 140.747 71.2533 145 76.5 145C81.7467 145 86 140.747 86 135.5C86 130.253 81.7467 126 76.5 126Z",
    fill: "#34A597"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 145L77.0938 140.844H80.0625L84.2188 145H81.25Z",
    fill: "#34A597"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 126,
    width: 123,
    height: 6,
    rx: 2,
    fill: "#C7D6EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 160,
    width: 123,
    height: 6,
    rx: 2,
    fill: "#C7D6EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 136,
    width: 71,
    height: 6,
    rx: 2,
    fill: "#C7D6EA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 147,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 147,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 181,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 181,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 170,
    width: 71,
    height: 6,
    rx: 2,
    fill: "#C7D6EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35209_77808",
    x: 13.2,
    y: 40,
    width: 253.6,
    height: 189.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77808"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77808",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_35209_77808",
    x: 51,
    y: 63,
    width: 178,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77808"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77808",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35209_77808",
    x1: 140,
    y1: 213.2,
    x2: 140,
    y2: 241.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E9BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9F3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon02);
export default __webpack_public_path__ + "static/media/info_icon02.b492b5ba591b90124dc5c63b9e1b75a5.svg";
export { ForwardRef as ReactComponent };